import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

export const guestGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const token = authService.getToken();

    // If token exists and isn't expired
    if (token && !authService.hasTokenExpired()) {
        // Redirect to dashboard
        router.navigate(['/b2bdashboard']);
        return false;
    }

    return true;
};